define([
    './ButtonSelectTypekey',
    './ButtonSelectTerm',
    './ChangeFreeGarageTermSelectButton',
    './CountryChooser',
    './BaslerDateCombo',
    './BaslerDateUtilService',
    './services/TextRetrievalService',
    './services/MagnoliaService',
    './baslercitypicker/BaslerCityPicker',
    './BaslerAnimatedCollapse',
    './BaslerInfoLink',
    './BaslerInfoButton',
    './BaslerStickyHelp',
    './BaslerMatriculationNumberHelp',
    './BaslerListItemSelector',
    './BaslerListItemSelectorTypekey',
    './BaslerListItemSelectorTerm',
    './NumberIncrementer',
    './BaslerToggler',
    './BaslerCheckbox',
    './BaslerErrorCtrlGroupDirective',
    './BaslerLoadingIndicatorDirective',
    './OfferActionsButtonBar',
    './BaslerCompanySearch',
    './BaslerConfirmationsDirective',
    './services/BaslerCompanySearchService',
    './services/BaslerDealerSearchService',
    './services/GoogleTagManagerService',
    './services/ContextService',
    './services/LoggingService',
    './services/LoggingDataService',
    './services/RecurrentUserService',
    './BaslerCollapsableSection',
    './BaslerSelectBox',
    './filters/SubmissionNumberFormatter',
    './constants/BaslerLoggingConstants',
    '../transport/TransportUtil',
    './services/VisitorIdService',
    './services/SessionIdService',
], (ButtonSelectTypekey,
    ButtonSelectTerm,
    ChangeFreeGarageTermSelectButton,
    CountryChooser,
    BaslerDateCombo,
    BaslerDateUtilService,
    TextRetrievalService,
    MagnoliaService,
    BaslerCityPicker,
    BaslerAnimatedCollapse,
    BaslerInfoLink,
    BaslerInfoButton,
    BaslerStickyHelp,
    BaslerMatriculationNumberHelp,
    BaslerListItemSelector,
    BaslerListItemSelectorTypekey,
    BaslerListItemSelectorTerm,
    NumberIncrementer,
    BaslerToggler,
    BaslerCheckbox,
    BaslerErrorCtrlGroupDirective,
    BaslerLoadingIndicatorDirective,
    OfferActionsButtonBar,
    BaslerCompanySearch,
    BaslerConfirmationsDirective,
    BaslerCompanySearchService,
    BaslerDealerSearchService,
    GoogleTagManagerService,
    ContextService,
    LoggingService,
    LoggingDataService,
    RecurrentUserService,
    BaslerCollapsableSection,
    BaslerSelectBox,
    SubmissionNumberFormatter,
    BaslerLoggingConstants,
    TransportUtil,
    VisitorIdService,
    SessionIdService
) =>{

    return angular.module('edge.platform.basler', ['ui.bootstrap', 'edge.platform.l10n', 'edge.platform.base', 'edge.platform.util'])
        .directive('buttonSelectTypekey', ButtonSelectTypekey)
        .directive('buttonSelectTerm', ButtonSelectTerm)
        .directive('changeFreeGarageTermSelectButton', ChangeFreeGarageTermSelectButton)
        .directive('countryChooser', CountryChooser)
        .directive('baslerDateCombo', BaslerDateCombo)
        .directive('baslerCityPicker', BaslerCityPicker)
        .directive('baslerAnimatedCollapse', BaslerAnimatedCollapse)
        .directive('baslerInfoLink', BaslerInfoLink)
        .directive('baslerInfoButton', BaslerInfoButton)
        .directive('baslerStickyHelp', BaslerStickyHelp)
        .directive('baslerMatriculationNumberHelp', BaslerMatriculationNumberHelp)
        .directive('baslerListItemSelector', BaslerListItemSelector)
        .directive('baslerListItemSelectorTypekey', BaslerListItemSelectorTypekey)
        .directive('baslerListItemSelectorTerm', BaslerListItemSelectorTerm)
        .directive('numberIncrementer', NumberIncrementer)
        .directive('offerActionsButtonBar', OfferActionsButtonBar)
        .directive('baslerToggler', BaslerToggler)
        .directive('baslerCheckbox', BaslerCheckbox)
        .directive('baslerErrorCtrlGroup', BaslerErrorCtrlGroupDirective)
        .directive('baslerCompanySearch', BaslerCompanySearch)
        .directive('baslerConfirmations', BaslerConfirmationsDirective)
        .directive('baslerLoadingIndicator', BaslerLoadingIndicatorDirective)
        .directive('baslerCollapsableSection', BaslerCollapsableSection)
        .directive('baslerSelectBox', BaslerSelectBox)
        .factory('BaslerDateUtilService', BaslerDateUtilService)
        .factory('TextRetrievalService', TextRetrievalService)
        .factory('MagnoliaService', MagnoliaService)
        .factory('BaslerCompanySearchService', BaslerCompanySearchService)
        .factory('BaslerDealerSearchService', BaslerDealerSearchService)
        .factory('GoogleTagManagerService', GoogleTagManagerService)
        .factory('ContextService', ContextService)
        .factory('LoggingService', LoggingService)
        .factory('LoggingDataService', LoggingDataService)
        .factory('TransportUtil', TransportUtil)
        .factory('RecurrentUserService', RecurrentUserService)
        .factory('VisitorIdService', VisitorIdService)
        .factory('SessionIdService', SessionIdService)
        .filter('formatSubmissionNumber', SubmissionNumberFormatter)
        .constant('BaslerLoggingConstants', BaslerLoggingConstants);
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/module.js